import { GridItem } from '@components/GridItem';
import { HeavyPaper } from '@components/HeavyPaper';
import { VerticalGrid } from '@components/VerticalGrid';
import { useData } from '@hooks/useData';
import { useField } from '@hooks/useField';
import useLoading from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { useModalWindow } from '@hooks/useModalWindow';
import { makeStyles } from '@material-ui/core';
import { CaixaRegistrarCreditoModal } from '@mod/Caixa/CaixaRegistrarCreditoModal';
import { CaixaRegistrarDebitoModal } from '@mod/Caixa/CaixaRegistrarDebitoModal';
import { CaixaTable } from '@mod/Caixa/CaixaTable';
import { FaturaDetalheModal } from '@mod/Fatura/FaturaDetalheModal';
import { ICaixaItem } from '@model/CaixaItem';
import { ICaixaFilter, ICaixaItemRecord, useCaixaService } from '@services/CaixaService';
import React from 'react';
import { CaixaFilter } from './CaixaFilter';

export type HomeCaixaProps = {
}

export function HomeCaixa (props: HomeCaixaProps) {
    const dataCaixaField = useField(new Date(), "dataCaixa");
    const caixaData = useData<ICaixaItemRecord, ICaixaFilter>();
    const loading = useLoading();
    const message = useMessage();
    const caixaService = useCaixaService();
    const creditoModal = useModalWindow();
    const debitoModal = useModalWindow();
    const faturaDetalheModal = useModalWindow();
    const cls = useStyles();
    
    const handlePrint = React.useCallback(() => {
        const periodoDe = dataCaixaField.value;
        const periodoAte = dataCaixaField.value;
        window.open(`/ImprimirCaixa/${periodoDe}/${periodoAte}`);
    }, [dataCaixaField.value]);

    const listarItens = React.useCallback(() => {
        if (!loading.isLoading && dataCaixaField.value !== null && dataCaixaField.value !== undefined) {
            loading.start();
            caixaService.listarPorData(dataCaixaField.value)
                .then(caixaData.handleDataResponse)
                .catch(message.showException)
                .finally(loading.stop);
        }
    }, [caixaData.handleDataResponse, caixaService, dataCaixaField.value, loading, message.showException]);

    const handleCaixaItemRegistrado = React.useCallback((caixaItem: ICaixaItem) => {
        listarItens();
    }, [listarItens]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    React.useEffect(listarItens, [dataCaixaField.value]);

    return (
        <React.Fragment>
            <HeavyPaper>
                <VerticalGrid>
                    <GridItem>
                        <CaixaFilter
                            creditoModal={creditoModal}
                            debitoModal={debitoModal}
                            dataCaixaField={dataCaixaField}
                            onPrintClick={handlePrint}
                            onRefreshClick={listarItens}
                        />
                    </GridItem>

                    <GridItem>
                        <CaixaTable
                            data={caixaData}
                            isLoading={loading.isLoading}
                            faturaDetalheModal={faturaDetalheModal}
                            tableContainerProps={{
                                className: cls.homeTable
                            }}
                        />
                    </GridItem>
                </VerticalGrid>
            </HeavyPaper>

            {
                caixaData.focusedRow && caixaData.focusedRow.faturaId !== undefined && (
                    <FaturaDetalheModal 
                        faturaId={caixaData.focusedRow.faturaId}
                        modal={faturaDetalheModal}
                    />
                )
            }

            <CaixaRegistrarCreditoModal 
                modal={creditoModal}
                onCaixaItemRegistrado={handleCaixaItemRegistrado}
            />

            <CaixaRegistrarDebitoModal 
                modal={debitoModal}
                onCaixaItemRegistrado={handleCaixaItemRegistrado}
            />
        </React.Fragment>
    )
}

const useStyles = makeStyles(theme => ({
    homeTable : {
        height: 'calc(100vh - 180px)'
    }
}));